import { createSelector } from 'reselect'
import { Shared } from 'types/Shared'
import { getShared } from './helpers'

export const getIsMobileTraffic = createSelector(
  [getShared],
  ({ isMobileTraffic }: Shared): boolean => isMobileTraffic || false
)
